export default "__VITE_ASSET__DEHLKVIV__"